import * as React from 'react';

type LabelProps = React.ClassAttributes<HTMLLabelElement> &
  React.LabelHTMLAttributes<HTMLLabelElement> & {
    /** The content of the label. */
    children: React.ReactNode;
  };

/**
 * Labels are a type of **atom** that represent a `<label>` element.
 */
const Label: React.FC<LabelProps> = ({ ...rest }) => {
  return (
    <label
      className={rest.className}
      css={{
        boxSizing: 'border-box',
        color: '#4D555C',
        fontFamily: 'Roboto, sans-serif',
        fontSize: '16px',
        lineHeight: '20px',
      }}
      {...rest}
    />
  );
};

export default Label;
